<template>
	<div>
		<AppHeader title="My 쿠폰함" is-history />
		<AppContent>
			<CouponState />
		</AppContent>
		<AppFooter />
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppFooter from '@/components/common/AppFooter';
import AppContent from '@/components/common/AppContent';
import CouponState from '@/components/CouponState';

export default {
	components: {
		AppHeader,
		AppFooter,
		AppContent,
		CouponState,
	},
};
</script>
